import React, { useContext, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { jt, t } from 'ttag'
import { useLocation } from 'react-router-dom'

import { sessionStarted, startSession, verifyMembership } from '@h2/features/auth'
import { Globals } from '@h2/globals'

import APIResponse from '../../../components/APIResponse'
import * as actions from '../../../actions/combineAccountActions'
import { findMatchingAccounts } from '../../../actions/combineAccountActions'
import ActionButton from '../../../components/ActionButton'
import { useInitDispatch, useTitleChange } from '../../../util/hooks'
import { browserHistory } from '../../../Routes'

const CombineAccountsChoose = () => {
  useTitleChange(t`Have you been here before?`)
  useInitDispatch(findMatchingAccounts())
  const { postSigninURI, environment, setViewMode } = useContext(Globals)
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const [options, setOptions] = useState({
    selectedOption: '',
    combineWithAccount: null
  })
  const { matchingAccountsRequest, combineAccountsChoiceRequest } = useSelector(
    state => state.combineAccounts
  )
  const handleMergeAction = () => {
    switch (options.selectedOption) {
      case 'skip':
        return dispatch(actions.skipCombination()).then(({ user, membership }) => {
          if (user) {
            dispatch(startSession({ user, environment, setViewMode }))
            dispatch(
              sessionStarted({
                inDialog: false,
                postSigninURI,
                pathname
              })
            )
          } else if (membership) {
            dispatch(verifyMembership(membership))
          } else {
            /*
             * If no session was started and there is no membership to accept,
             * we'll go through registration
             * which will pre-populate information from oauth and ultimately
             * require site membership
             */
            browserHistory.push('/register')
          }
        })
      case 'other':
        browserHistory.push('/combine/auth')

        return null
      default:
        return dispatch(
          actions.combineAccountsBySelection(options.combineWithAccount)
        ).then(({ user, membership }) => {
          if (user) {
            dispatch(startSession({ user, environment, setViewMode }))
            dispatch(
              sessionStarted({
                inDialog: false,
                postSigninURI,
                pathname
              })
            )
          } else if (membership) {
            dispatch(verifyMembership(membership))
          } else {
            /*
             * If no session was started and there is no membership to accept,
             * we'll go through registration
             * which will pre-populate information from oauth and ultimately
             * require site membership
             */
            browserHistory.push('/register')
          }

          return user
        })
    }
  }
  const showHandleCheck = (id, linkText, sub, accountId = null) => {
    return (
      <a
        onClick={() => {
          setOptions({
            selectedOption: id,
            combineWithAccount: accountId
          })
        }}>
        <div
          className={`combined-check ${
            options.selectedOption === id ? 'checked' : 'unchecked'
          }`}>
          {options.selectedOption === id ? <i className="check"></i> : null}
        </div>
        <div>
          <span className="combine-main">{linkText}</span>
          <span className="combine-sub">{sub}</span>
        </div>
      </a>
    )
  }
  const buttonText = () => {
    switch (options.selectedOption) {
      case 'skip':
        return t`Continue`
      case 'other':
        return t`Choose Account`
      default:
        return t`Combine Accounts`
    }
  }

  return (
    <div>
      <p className="title">
        {jt`If you have used ${dynamicValues.systemName}, or any other Headed2 site before, 
                                you can combine this sign-in with your existing account and get to access any work you 
                                have already done.`}
      </p>
      <h3 className="section-heading">{t`Would you like to:`}</h3>

      <ul className="combine-account-sso">
        <h4>{t`Combine Data: `}</h4>
        <APIResponse request={matchingAccountsRequest}>
          {matchingAccounts => {
            return matchingAccounts?.map((account, idx) => {
              return (
                <li key={`account-${idx}`}>
                  {' '}
                  {showHandleCheck(
                    `existing.${idx}`,
                    account.name,
                    t`this is an existing account which matches your email address`,
                    account
                  )}
                </li>
              )
            })
          }}
        </APIResponse>
        <li>
          {' '}
          {showHandleCheck(
            `other`,
            t`I want to combine with another account`,
            t`you will need to enter username/password on next screen`
          )}
        </li>

        <br />
        <h4>{t`Don't Combine:`}</h4>
        <li>
          {' '}
          {showHandleCheck(
            `skip`,
            t`I don't want to combine an account`,
            t`I don't have another account, or I don't wish to combine the data in this account`
          )}
        </li>
      </ul>

      <div className="text-right">
        <ActionButton
          className={`btn btn-${options.selectedOption ? 'success' : 'default'}`}
          request={combineAccountsChoiceRequest}
          disabled={!options.selectedOption}
          onClick={handleMergeAction}>
          {options.selectedOption ? buttonText() : t`Select an option above to continue`}
        </ActionButton>
      </div>
    </div>
  )
}

export { CombineAccountsChoose }
